import htmlReactParser from 'html-react-parser';
import React from 'react';
import styled from '@emotion/styled';
import { SpacingProps } from './withStyleSystem/withSpacingStyles';
import { Link } from './styles';
import { __t } from './i18n';

type HtmlParserProps = {
  data: string;
  hasMore?: boolean;
  onShowMore?: () => void;
} & SpacingProps;

const ReadMore = styled(Link)(({ theme }) => ({
  display: 'inline-block',
  color: theme.palette.foreground[100],
  marginRight: theme.spacing(1),
  borderBottom: '1px solid',
  lineHeight: theme.font.lineHeight.compact,
}));

export default function HtmlParser({
  data,
  hasMore,
  onShowMore,
}: HtmlParserProps) {
  return (
    <>
      {htmlReactParser(data)}
      {hasMore && (
        <ReadMore href="#" onClick={(e) => { e.preventDefault(); onShowMore?.(); }}>
          {__t('continue')}
        </ReadMore>
      )
      }
    </>
  );
}
